var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcInfoBreakersWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icInfoBreakers") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Open-profile---Deal-breakers",
    transform: "translate(-112.000000, -664.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "White-content",
    transform: "translate(0.000000, 370.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "First-description"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icInfoBreakers",
    transform: "translate(113.000000, 295.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "information"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5,0 C3.36424805,0 0,3.36424805 0,7.5 C0,11.635752 3.36424805,15 7.5,15 C11.635752,15 15,11.635752 15,7.5 C15,3.36424805 11.635752,0 7.5,0 Z",
    id: "Shape",
    stroke: "#fff",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.18749023,12.5000098 C6.67051758,12.5000098 6.24999023,12.0794824 6.24999023,11.5625098 C6.24999023,11.0455371 6.67051758,10.6250098 7.18749023,10.6250098 C7.70446289,10.6250098 8.12499023,11.0455371 8.12499023,11.5625098 C8.12499023,12.0794824 7.70446289,12.5000098 7.18749023,12.5000098 Z",
    id: "Path",
    fill: "#fff",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12499023,8.68775391 L8.12499023,9.68750977 C8.12499023,9.86024414 7.98521484,10.0000195 7.81248047,10.0000195 L6.5625,10.0000195 C6.38976562,10.0000195 6.24999023,9.86024414 6.24999023,9.68750977 L6.24999023,8.12501953 C6.24999023,7.43592773 6.8109082,6.87500977 7.5,6.87500977 C8.1890918,6.87500977 8.75000977,6.3140918 8.75000977,5.625 C8.75000977,4.9359082 8.1890918,4.37499023 7.5,4.37499023 C6.8109082,4.37499023 6.24999023,4.9359082 6.24999023,5.625 L6.24999023,5.93750977 C6.24999023,6.11024414 6.11021484,6.25001953 5.93748047,6.25001953 L4.6875,6.25001953 C4.51476562,6.25001953 4.37499023,6.11024414 4.37499023,5.93750977 L4.37499023,5.625 C4.37499023,3.90196289 5.77696289,2.49999023 7.5,2.49999023 C9.22303711,2.49999023 10.6250098,3.90199219 10.6250098,5.625 C10.6250098,7.12464844 9.56847656,8.39540039 8.12499023,8.68775391 Z",
    id: "Path",
    fill: "#fff",
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInfoBreakersWhite);
export default __webpack_public_path__ + "static/media/icInfoBreakersWhite.fcfff93a1cf969d2bbed746e0a46a70d.svg";
export { ForwardRef as ReactComponent };